<template>
  <b-list-group v-if="level === 0">
    <slot></slot>
  </b-list-group>
  <b-list-group-item v-else-if="level === 1 && header" class="metadata-list-group-item">
    <h5 v-if="header">{{header}}</h5>
    <slot></slot>
  </b-list-group-item>
  <div v-else :class="{ 'ml-4': indent }">
    <h6 v-if="header">{{header}}</h6>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "MetadataNodeWrapper",
  props: {
    level: Number,
    header: String
  },
  computed: {
    indent() {
      return this.level > 1 && this.header;
    }
  }
};
</script>